var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupeeDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0469 23.2969H3.76562C2.59687 23.2969 1.64062 22.3406 1.64062 21.1719V3.64062C1.64062 2.47187 2.59687 1.51562 3.76562 1.51562H17.0469C18.2156 1.51562 19.1719 2.47187 19.1719 3.64062V21.1719C19.1719 22.3406 18.2156 23.2969 17.0469 23.2969Z",
    fill: "white",
    stroke: "#AA013F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2344 26.4844H6.95313C5.78438 26.4844 4.82812 25.5281 4.82812 24.3594V6.82813C4.82812 5.65938 5.78438 4.70312 6.95313 4.70312H20.2344C21.4031 4.70312 22.3594 5.65938 22.3594 6.82813V24.3594C22.3594 25.5281 21.4031 26.4844 20.2344 26.4844Z",
    fill: "white",
    stroke: "#AA013F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73438 19.1204H17.4541",
    stroke: "#AA013F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7617 22.2961H16.426",
    stroke: "#AA013F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.221 9.98574L15.9591 10.8794H10.9668L11.2287 9.98574H16.221ZM13.879 16.0104L11.0592 12.5589L11.0438 11.9118H12.446C12.8107 11.9118 13.1214 11.8604 13.3782 11.7577C13.635 11.6524 13.8315 11.4958 13.9676 11.2877C14.1037 11.0772 14.1717 10.8127 14.1717 10.4942C14.1717 10.0243 14.0305 9.65575 13.748 9.38867C13.4655 9.11903 13.0315 8.9842 12.446 8.9842H10.9668L11.2287 8.12134H12.446C13.0726 8.12134 13.5862 8.22534 13.9868 8.43336C14.39 8.6388 14.6879 8.92129 14.8805 9.28081C15.0757 9.63777 15.1733 10.0422 15.1733 10.4942C15.1733 10.9025 15.0834 11.2788 14.9036 11.6229C14.7264 11.9644 14.4414 12.2392 14.0485 12.4472C13.6581 12.6552 13.1419 12.7592 12.4999 12.7592H12.4768L15.0808 15.9488V16.0104H13.879ZM16.221 8.12134L15.9591 9.01502L12.03 8.9842L12.2919 8.12134H16.221Z",
    fill: "#02006B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeeDocs);
export default __webpack_public_path__ + "static/media/RupeeDocs.2c9c37e9d478f66f65076f43f2cfba88.svg";
export { ForwardRef as ReactComponent };